module.exports = __webpack_public_path__ + "media/regioner-2020-small-class-3mNQP.svg";